module.exports = __webpack_public_path__ + "static/20-3-ab84663694561858f76eb6751f3857b9.jpg";